const formatNumber = (number) => {
    if (number === undefined) {
        return '';
    }

    if (number > 1000000) {
        return `${Math.floor(number / 100000) / 10}M`;
    }

    if (number > 1000) {
        return `${Math.floor(number / 1000)}K`;
    }

    return number.toString();
};

export default formatNumber
